<template>
<ts-dropdown
    :placeholder="placeholderOrValue"
    :size="size"
    :width="width"
    :popover-width="260"
    :open="open"
    :disabled="disabled"
    @click="handleDropdownClick"
    @close="handleSaveClick"
  >
  <template #icon>
    <span style="display:inline-block; margin-right:10px;">
      <ts-icon icon="time" title="Clock" size="small"/>
    </span>
  </template>
    <div v-if="origin" class="origin">
      <span>
        <a class="origin-link" @click="handleOriginClick">&lt;&lt;</a>
      </span>
      <span>
        <a class="origin-link" @click="handleNowClick">&gt;&gt;</a>
      </span>
    </div>
    <div class="" style="height: 0; overflow:hidden;">
    <el-time-select
      ref="timePicker"
      @blur="onBlur"
      :value="value"
      @input="handleTimeSelected"
      :picker-options="{
    start: '00:00',
    step: '00:30',
    end: '23:59'
  }"
      style="opacity: 0;"
      placeholder="Choisissez un horaire">
    </el-time-select>
    </div>
    <!-- <template #footer>
      <div class="actions">
        <span>
          <ts-link @click="handleResetClick">Reset</ts-link>
        </span>
        <ts-link type="primary" @click="handleSaveClick">Save</ts-link>
      </div>
    </template> -->
  </ts-dropdown>

</template>

<style lang="scss" scoped>
.origin {
  font-family: Roboto;
  font-size: 12px;
  color: #6d7587;
  display: flex;
  justify-content: space-between;
  margin: 12px;

  .origin-link {
    cursor: pointer;
  }
}

.actions {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 12px;
}
</style>

<script>
import { format } from 'date-fns';

export default {
  props: {
    mode: {
      type: String,
      default: 'range'
    },
    placeholder: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 300
    },
    size: {
      type: String,
      default: 'small'
    },
    value: {
      type: [Object, Date, String],
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    origin: {
      type: Date,
      default: null
    }
  },
  data() {
    return {
      dates: null,
      open: false
    };
  },
  mounted() {
  },
  computed: {
    placeholderOrValue() {
      if (this.value) {
        return this.value
      }
      return this.placeholder;
    }
  },
  methods: {
    handleDropdownClick() {
      this.open = !this.open;
      this.$nextTick(() => this.$refs.timePicker.focus());
    },
    onBlur() {
      this.open = false;
    },
    handleOriginClick() {
      this.$refs.datePicker.$refs.calendar.$refs.calendar.move(this.origin);
    },
    handleNowClick() {
      this.$refs.datePicker.$refs.calendar.$refs.calendar.move(new Date());
    },
    handleResetClick() {
      this.open = false;
      this.$emit('input', null);
    },
    handleTimeSelected(time) {
      this.$nextTick(() => this.$refs.timePicker.blur());
      this.$emit('input', time)
      this.open = false;
    },
    handleSaveClick() {
    }
  }
};
</script>
